import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { cedoliniList, cuList } from '../../services/api_dipendenti';
import { Link } from 'wouter';
// import checkicon
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/20/solid';

import Empty from '../../components/empty';

import { Popover } from '@headlessui/react';
import Fetching from "../../components/fetching";
import Modal from "../../components/modal";

import moment from "moment"
import { months } from "../../config"
import SlideOverPdf from "../../components/slide_over_pdf";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function ArCu() {
  const { token } = useContext(AuthContext);

  const [cu, setCu] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await cuList(token);
        setCu(response);
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
      }
    }
    fetchData();
  }, [token]);

  return <div>
    <Popover as="header" className={`bg-indigo-200`}>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
          <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
            <div className="flex justify-center my-2 py-2">
              <h2 className="text-center text-2xl font-semibold text-indigo-800">Le mie CU</h2>
            </div>
          </div>
        </div>
      </div>
    </Popover>
    
      {loading && <Fetching />}

      {(!loading && cu.length > 0) && (
      <div className="px-4 sm:px-6 lg:px-8 mt-5">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">Certificazioni Uniche</h1>
            <p className="mt-2 text-sm text-gray-700">
              Qui puoi vedere le tue CU e scaricarle in formato PDF.
            </p>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">

          </div>
        </div>
        <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <table className="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                  Anno
                </th>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                  Anno Riferimento
                </th>
                {/* <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                >
                  Caricata il
                </th> */}
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                >
                  Letta
                </th>
                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                  
                </th>
              </tr>
            </thead>
            <tbody>
            {cu
              .slice()
              .sort((a, b) => b.anno - a.anno)
              .map((c, planIdx) => (
                <tr key={c.id}>
                  <td
                    className={classNames(
                      planIdx === 0 ? '' : 'border-t border-transparent',
                      'relative py-4 pl-4 pr-3 text-sm sm:pl-6'
                    )}
                  >
                    <div className="font-medium text-gray-900">
                      {c.anno}
                    </div>
                    
                  {/* <div className="mt-1 flex flex-col text-gray-500 sm:block lg:hidden">
                    <span>
                      Caricata il <time dateTime={c.created_at}>{moment(c.created_at).format('DD/MM/YYYY HH:mm')}</time>
                    </span>
                  </div> */}
                    {planIdx !== 0 ? <div className="absolute -top-px left-6 right-0 h-px bg-gray-200" /> : null}
                  </td>
                  <td
                    className={classNames(
                      planIdx === 0 ? '' : 'border-t border-gray-200',
                      'hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell'
                    )}
                  >
                    {c.anno_riferimento}
                  </td>
                  {/* <td
                    className={classNames(
                      planIdx === 0 ? '' : 'border-t border-gray-200',
                      'hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell'
                    )}
                  >
                    <time dateTime={c.created_at}>{moment(c.created_at).format('DD/MM/YYYY HH:mm')}</time>
                  </td> */}
                  <td
                    className={classNames(
                      planIdx === 0 ? '' : 'border-t border-gray-200',
                      'hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell'
                    )}
                  >
                    {c.read_at ? (
                      <CheckCircleIcon className='w-5 h-5 text-teal-500 mr-1' />
                    ) : (
                      <XCircleIcon className='w-5 h-5 text-red-500 mr-1' />
                    )}
                  </td>
                  
                  <td
                    className={classNames(
                      planIdx === 0 ? '' : 'border-t border-transparent',
                      'relative py-3.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6'
                    )}
                  >
                    <Link
                      to={`/areariservata/cu/${c.id}`}
                      className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      Leggi
                    </Link>
                    {planIdx !== 0 ? <div className="absolute -top-px left-0 right-6 h-px bg-gray-200" /> : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      )}

      {(!loading && cu.length === 0) && (
        <Empty />
      )}

      
  </div>
}